/* eslint eslint-comments/no-unlimited-disable: off */
/* eslint-disable */
// @ts-nocheck
// automatically generated by the FlatBuffers compiler, do not modify
export var Image2DMode;
(function (Image2DMode) {
    Image2DMode[Image2DMode["L_U8"] = 0] = "L_U8";
    Image2DMode[Image2DMode["L_F32"] = 1] = "L_F32";
    Image2DMode[Image2DMode["L_F64"] = 2] = "L_F64";
    Image2DMode[Image2DMode["LA_U8"] = 3] = "LA_U8";
    Image2DMode[Image2DMode["LA_F32"] = 4] = "LA_F32";
    Image2DMode[Image2DMode["LA_F64"] = 5] = "LA_F64";
    Image2DMode[Image2DMode["RGB_U8"] = 6] = "RGB_U8";
    Image2DMode[Image2DMode["RGB_F32"] = 7] = "RGB_F32";
    Image2DMode[Image2DMode["RGB_F64"] = 8] = "RGB_F64";
    Image2DMode[Image2DMode["RGBA_U8"] = 9] = "RGBA_U8";
    Image2DMode[Image2DMode["RGBA_F32"] = 10] = "RGBA_F32";
    Image2DMode[Image2DMode["RGBA_F64"] = 11] = "RGBA_F64";
    Image2DMode[Image2DMode["BGR_U8"] = 12] = "BGR_U8";
    Image2DMode[Image2DMode["BGR_F32"] = 13] = "BGR_F32";
    Image2DMode[Image2DMode["BGR_F64"] = 14] = "BGR_F64";
    Image2DMode[Image2DMode["BGRA_U8"] = 15] = "BGRA_U8";
    Image2DMode[Image2DMode["BGRA_F32"] = 16] = "BGRA_F32";
    Image2DMode[Image2DMode["BGRA_F64"] = 17] = "BGRA_F64";
    Image2DMode[Image2DMode["YCbCr_U8"] = 18] = "YCbCr_U8";
    Image2DMode[Image2DMode["BayerRG_U8"] = 19] = "BayerRG_U8";
    Image2DMode[Image2DMode["BayerRG_U10"] = 20] = "BayerRG_U10";
    Image2DMode[Image2DMode["BayerRG_U12"] = 21] = "BayerRG_U12";
    Image2DMode[Image2DMode["JPEG"] = 22] = "JPEG";
    Image2DMode[Image2DMode["PNG"] = 23] = "PNG";
    Image2DMode[Image2DMode["GIF"] = 24] = "GIF";
    Image2DMode[Image2DMode["BMP"] = 25] = "BMP";
})(Image2DMode || (Image2DMode = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaW1hZ2UyLWRtb2RlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vLi4vc3JjL2xpYi9nZW5lcmF0ZWQvZmJzL3J2YWkvaW1hZ2UyLWRtb2RlLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFLLHNEQUFzRDtBQUN0RCxvQkFBb0I7QUFDcEIsY0FBYztBQUNsQixxRUFBcUU7QUFFdEUsTUFBTSxDQUFOLElBQVksV0EyQlg7QUEzQkQsV0FBWSxXQUFXO0lBQ3JCLDZDQUFRLENBQUE7SUFDUiwrQ0FBUyxDQUFBO0lBQ1QsK0NBQVMsQ0FBQTtJQUNULCtDQUFTLENBQUE7SUFDVCxpREFBVSxDQUFBO0lBQ1YsaURBQVUsQ0FBQTtJQUNWLGlEQUFVLENBQUE7SUFDVixtREFBVyxDQUFBO0lBQ1gsbURBQVcsQ0FBQTtJQUNYLG1EQUFXLENBQUE7SUFDWCxzREFBYSxDQUFBO0lBQ2Isc0RBQWEsQ0FBQTtJQUNiLGtEQUFXLENBQUE7SUFDWCxvREFBWSxDQUFBO0lBQ1osb0RBQVksQ0FBQTtJQUNaLG9EQUFZLENBQUE7SUFDWixzREFBYSxDQUFBO0lBQ2Isc0RBQWEsQ0FBQTtJQUNiLHNEQUFhLENBQUE7SUFDYiwwREFBZSxDQUFBO0lBQ2YsNERBQWdCLENBQUE7SUFDaEIsNERBQWdCLENBQUE7SUFDaEIsOENBQVMsQ0FBQTtJQUNULDRDQUFRLENBQUE7SUFDUiw0Q0FBUSxDQUFBO0lBQ1IsNENBQVEsQ0FBQTtBQUNWLENBQUMsRUEzQlcsV0FBVyxLQUFYLFdBQVcsUUEyQnRCIn0=